import { render, staticRenderFns } from "./cImagePreview.vue?vue&type=template&id=0f0d8233&scoped=true"
import script from "./cImagePreview.vue?vue&type=script&lang=js"
export * from "./cImagePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0d8233",
  null
  
)

export default component.exports